/**
 * A typed API error carrying the platform's machine-readable `code` (PRD §18.6),
 * so UI can branch on codes (e.g. `LOGIN_DISABLED_OIDC`, `APPLICANT_IS_TENANT_STAFF`)
 * rather than parsing English. The correlation id ties a user-visible failure back
 * to the backend trace/log/audit for support.
 *
 * `retryAfterSeconds` is the `Retry-After` header in delta-seconds (a busy 503
 * says when to come back, R8); `null` when absent or not delta-seconds.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: unknown;
  readonly correlationId: string | null;
  readonly retryAfterSeconds: number | null;

  constructor(
    status: number,
    code: string,
    message: string,
    details: unknown,
    correlationId: string | null,
    retryAfterSeconds: number | null = null,
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.correlationId = correlationId;
    this.retryAfterSeconds = retryAfterSeconds;
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}
